export const setupFullscreenBlock = () => {
  // Override the native exitFullscreen methods
  const overrideNativeFullscreen = () => {
    // Store original methods
    const original = {
      exitFullscreen: Document.prototype.exitFullscreen,
      webkitExitFullscreen: Document.prototype.webkitExitFullscreen,
      mozCancelFullScreen: Document.prototype.mozCancelFullScreen,
      msExitFullscreen: Document.prototype.msExitFullscreen
    };

    // Override each exit method
    Document.prototype.exitFullscreen = function() { return false; };
    Document.prototype.webkitExitFullscreen = function() { return false; };
    Document.prototype.mozCancelFullScreen = function() { return false; };
    Document.prototype.msExitFullscreen = function() { return false; };

    return original;
  };

  // Block ESC key through multiple methods
  const blockEscKey = (event) => {
    if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return false;
    }
  };

  // Enter fullscreen with all possible methods
  const enterFullscreen = async (element) => {
    const methods = [
      'requestFullscreen',
      'webkitRequestFullscreen',
      'mozRequestFullScreen',
      'msRequestFullscreen'
    ];

    for (const method of methods) {
      if (element[method]) {
        try {
          await element[method]();
          break;
        } catch (e) {
          console.warn(`Failed to enter fullscreen using ${method}`, e);
          continue;
        }
      }
    }
  };

  // Add multiple event listeners at different phases
  window.addEventListener('keydown', blockEscKey, { capture: true });
  window.addEventListener('keyup', blockEscKey, { capture: true });
  document.addEventListener('keydown', blockEscKey, { capture: true });
  document.addEventListener('keyup', blockEscKey, { capture: true });
  document.documentElement.addEventListener('keydown', blockEscKey, { capture: true });
  document.documentElement.addEventListener('keyup', blockEscKey, { capture: true });

  // Override the default fullscreen behavior
  const original = overrideNativeFullscreen();

  // Return cleanup function
  return () => {
    // Restore original methods
    Document.prototype.exitFullscreen = original.exitFullscreen;
    Document.prototype.webkitExitFullscreen = original.webkitExitFullscreen;
    Document.prototype.mozCancelFullScreen = original.mozCancelFullScreen;
    Document.prototype.msExitFullscreen = original.msExitFullscreen;

    // Remove event listeners
    window.removeEventListener('keydown', blockEscKey, { capture: true });
    window.removeEventListener('keyup', blockEscKey, { capture: true });
    document.removeEventListener('keydown', blockEscKey, { capture: true });
    document.removeEventListener('keyup', blockEscKey, { capture: true });
    document.documentElement.removeEventListener('keydown', blockEscKey, { capture: true });
    document.documentElement.removeEventListener('keyup', blockEscKey, { capture: true });
  };
};

// In your Index.js component where navigation happens:
